import { areaFdsActions } from '../actions'

const {
  FETCHING_AREA_FDS,
  FETCH_AREA_FDS,
  FETCH_AREA_FDS_ERROR
} = areaFdsActions

const initialState = {
  loading: false,
  error: null, // null, 'invalid' (QR sem validade) ou 'failed' (vale tentar de novo)
  area: {
    name: '',
    code: ''
  },
  fds: []
}

const areaFds = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_AREA_FDS:
      return { ...state, loading: true, error: null }

    case FETCH_AREA_FDS:
      return { ...state, loading: false, area: action.area, fds: action.fds }

    case FETCH_AREA_FDS_ERROR:
      return { ...state, loading: false, error: action.error }

    default:
      return state
  }
}

export default areaFds



// WEBPACK FOOTER //
// ./src/reducers/areaFds.js